import { DeceasedProfile } from './deceasedProfile';
import { Booking } from './Booking';
export class BookingDeceasedProfiles {

    public booking: Booking
    public deceasedProfiles: DeceasedProfile[]

    constructor(
        booking: Booking,
        deceasedProfiles: DeceasedProfile[],
    ) {
        this.booking = booking;
        this.deceasedProfiles = deceasedProfiles
    }
}
